export default __webpack_public_path__ + "static/media/7VH80.7c0c230d.png";